/**
 * ActivityAuditMarketing — Marketing Activity Audit placeholder.
 *
 * LOCKED DECISIONS:
 *   A3  Marketing view = "Coming soon" empty state for sprint.
 *       Live in continuation (July 1 +). Requires campaign_events + campaigns
 *       tables which do not exist yet.
 *
 * TENANT ISOLATION: tenant_id != 2 enforced when wired.
 */

import { tokens } from "@/components/operator/tokens";

export default function ActivityAuditMarketing() {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        minHeight: 400,
        gap: 16,
        padding: "48px 24px",
        textAlign: "center",
      }}
    >
      {/* Icon */}
      <div
        style={{
          width: 64,
          height: 64,
          borderRadius: "50%",
          background: tokens.color.surfaceMute,
          border: `1px solid ${tokens.color.border}`,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke={tokens.color.textSubtle} strokeWidth={1.5} strokeLinecap="round" strokeLinejoin="round">
          <path d="M22 12h-4l-3 9L9 3l-3 9H2" />
        </svg>
      </div>

      <div>
        <div
          style={{
            fontFamily: tokens.font.display,
            fontWeight: 700,
            fontSize: 20,
            color: tokens.color.textPrimary,
            marginBottom: 8,
          }}
        >
          Marketing Activity — Coming Soon
        </div>
        <div style={{ fontSize: 13, color: tokens.color.textMuted, maxWidth: 440, lineHeight: 1.6 }}>
          The Marketing Activity Audit view will display campaign sends, opens, clicks,
          MQL conversions, and marketing-attributed pipeline. It requires the
          <code style={{ fontSize: 11, background: "#EFEFEE", padding: "1px 4px", borderRadius: 3, margin: "0 3px" }}>campaign_events</code>
          and
          <code style={{ fontSize: 11, background: "#EFEFEE", padding: "1px 4px", borderRadius: 3, margin: "0 3px" }}>campaigns</code>
          tables, scheduled for July 2026.
        </div>
      </div>

      <div
        style={{
          background: tokens.color.surfaceMute,
          border: `1px solid ${tokens.color.border}`,
          borderRadius: tokens.radius.card,
          padding: "16px 24px",
          display: "flex",
          flexDirection: "column",
          gap: 8,
          width: "100%",
          maxWidth: 440,
          textAlign: "left",
        }}
      >
        <div style={{ fontSize: 11, fontWeight: 700, letterSpacing: "0.1em", textTransform: "uppercase", color: tokens.color.textSubtle }}>
          Planned KPIs
        </div>
        {["Sends", "Opens", "Clicks", "MQLs Generated", "Marketing Attribution"].map((kpi) => (
          <div
            key={kpi}
            style={{
              display: "flex", alignItems: "center", gap: 8,
              fontSize: 13, color: tokens.color.textMuted,
            }}
          >
            <div style={{ width: 6, height: 6, borderRadius: "50%", background: tokens.color.border, flexShrink: 0 }} />
            {kpi}
          </div>
        ))}
      </div>

      <div style={{ fontSize: 11, color: tokens.color.textSubtle }}>
        Locked decision A3 — sprint placeholder. Live in continuation sprint (July 2026).
      </div>
    </div>
  );
}
